import {
  RequiredLink,
  SchemaField,
  isRequiredLinkSchemaInterface,
  isRequiredLinkStorableSchema,
  isRequiredLinkTagSchema,
} from 'schemas/fields/SchemaFieldConstants';

export function isUneditableField(field: SchemaField): boolean {
  return field.isConvertedFromLink || field.isComputed || field.isSnapshot || Boolean(field.isUneditable);
}

interface SimplifiedRequiredLinkAttributes {
  tagSchema: string | null;
  schemaInterface: string | null;
  storableSchema: string | null;
}

export function simplifyRequiredLink(
  requiredLink: RequiredLink | null
): Omit<RequiredLink, 'tagSchema' | 'schemaInterface' | 'storableSchema'> & SimplifiedRequiredLinkAttributes {
  return {
    ...requiredLink,
    tagSchema: isRequiredLinkTagSchema(requiredLink) ? requiredLink.tagSchema.id : null,
    schemaInterface: isRequiredLinkSchemaInterface(requiredLink) ? requiredLink.schemaInterface.id : null,
    storableSchema: isRequiredLinkStorableSchema(requiredLink) ? requiredLink.storableSchema.id : null,
  };
}
